import { invokeApig }   from "../libs/awsLib";

//var globalUserId = localStorage.getItem('globalUserId'); // DONT USE THIS; if a user logs out and then back in it's still the old user id

export const getUserId = () => {
    var globalUserId = localStorage.getItem('globalUserId');

    return globalUserId;
}


export const invokeAddClientProgress = (title, photo_id, notes, height, weight, lean_tissue_mass_percent,
                                        lean_tissue_mass_weight, adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi,
                                        upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left,
                                        calf_right, calf_left, arm_right, arm_left, arm_flexed_right,
                                        arm_flexed_left, forearm_right, forearm_left, neck, shoulder) => {
    var globalUserId = getUserId();
    var trainer_id   = localStorage.getItem('globalUserTrainerId');
    var company_id   = localStorage.getItem('globalUserCompanyId');

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "setProgressTracker", company_id: company_id, user_id: globalUserId, trainer_id: trainer_id, photo_id: photo_id,
                title: title, comments: notes, height: height, weight: weight, lean_tissue_mass_percent: lean_tissue_mass_percent,
                lean_tissue_mass_weight: lean_tissue_mass_weight, adipose_tissue_mass_percent: adipose_tissue_mass_percent,
                adipose_tissue_mass_weight: adipose_tissue_mass_weight, bmi:bmi,
                upper_chest: upper_chest, lower_chest: lower_chest, abdomen: abdomen, waist: waist, hip: hip, thigh_right: thigh_right,
                thigh_left: thigh_left, calf_right: calf_right, calf_left: calf_left, arm_right: arm_right, arm_left: arm_left,
                arm_flexed_right: arm_flexed_right, arm_flexed_left: arm_flexed_left, forearm_right: forearm_right, forearm_left: forearm_left,
                neck: neck, shoulder: shoulder}
    });
}

/*************************************************************************************************/
/***********************************   ATHLETE SET SURVEY SECTION   ******************************/
/*************************************************************************************************/


export const invokeSetSurveyPreWorkout = (program_id, day_id, energy_level, hours_of_sleep, comments) => {
    var globalUserId = getUserId();
    var trainer_id   = localStorage.getItem('globalUserTrainerId');
    var company_id   = localStorage.getItem('globalUserCompanyId');

    if(hours_of_sleep === "Select") hours_of_sleep = 0;
    if(energy_level === "Select") energy_level = 0;

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "setSurveyPreWorkout", company_id: company_id, user_id: globalUserId, trainer_id: trainer_id, program_id: program_id, day_id: day_id, energy_level: energy_level, hours_of_sleep: hours_of_sleep, comments: comments }
    });
}

export const invokeSetSurveyPostWorkout = (program_id, day_id, postworkout_feeling, level_of_training, comments) => {
    var globalUserId = getUserId();
    var trainer_id   = localStorage.getItem('globalUserTrainerId');
    var company_id   = localStorage.getItem('globalUserCompanyId');

    if(postworkout_feeling === "Select") postworkout_feeling = 0;
    if(level_of_training === "Select") level_of_training = 0;

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "setSurveyPostWorkout", company_id: company_id, user_id: globalUserId, trainer_id: trainer_id, program_id: program_id, day_id: day_id, postworkout_feeling: postworkout_feeling, level_of_training: level_of_training, comments: comments }
    });
}

/*****************************************************************************************************/
/***********************************         ZOOM SECTION         ************************************/
/*****************************************************************************************************/

export const invokeGetZoom = async (user_role) => {
    var company_id   = localStorage.getItem('globalUserCompanyId');

    return await invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "generateZoomSignature", company_id: company_id, role: user_role }
    });
}

/*************************************************************************************************/
/***********************************   ATHLETE NOTE SECTION   ************************************/
/*************************************************************************************************/

export const invokeGetAthleteNotes = (exercise_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "getAthleteNotes", user_id: globalUserId, exercise_id: exercise_id }
    });
}

export const invokeSetAthleteNotes = (exercise_id, notes) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "setAthleteNotes", user_id: globalUserId, exercise_id: exercise_id, notes: notes }
    });
}

/*********************************************************************************************/
/***********************************   WORKOUT SECTION    ************************************/
/*********************************************************************************************/

export const invokeGetWorkoutFinished = (program_id, day_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "getWorkoutFinished", user_id: globalUserId, program_id: program_id, day_id: day_id }
    });
}

export const invokeSetProgramDayBeginTime = (program_id, day_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/program/getWorkout",
        method: "POST",
        body: { screen: "setProgramDayBeginTime", user_id: globalUserId, program_id: program_id, day_id: day_id }
    });
}

export const invokeGetAppMainUserId = (email) => {
    return invokeApig({
        path: `/athlete/utils/getAppMainUserId`,
        method: "POST",
        body: { email: email }
    });
}

export const invokeSetAthleteMarketplaceSubscriber = (user_id, program_id, program_mktplc_id) => {
    //var globalUserId = getUserId();
    var company_id   = localStorage.getItem('globalUserCompanyId');

    return invokeApig({
        path: `/athlete/program/getListAllPrograms`,
        method: "POST",
        body: { screen: "setAthleteMarketplaceSubscriber", user_id: user_id, company_id: company_id, program_id: program_id, program_mktplc_id: program_mktplc_id }
    });
}

export const invokeGetListAllMarketplacePrograms = (user_id) => {
    var company_id   = localStorage.getItem('globalUserCompanyId');

    return invokeApig({
        path: `/athlete/program/getListAllPrograms`,
        method: "POST",
        body: { screen: "getListAllMarketplacePrograms", user_id: user_id, company_id: company_id }
    });
}

export const invokeGetListAllPrograms = (user_id, company_id) => {
    //var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/program/getListAllPrograms`,
        method: "POST",
        body: { screen: "getListAllPrograms", user_id: user_id, company_id: company_id }
    });
}

/*export const invokeGetListAllSubPrograms = (company_id, category_id) => {
    return invokeApig({
        path: `/athlete/program/getListAllSubPrograms`,
        method: "POST",
        body: { user_id: globalUserId, company_id: company_id, category_id: category_id }
    });
}*/


/*******************************************/
/****   CHANGE globalUserId to UserId   ****/
export const invokeGetProgramSummary = (program_id, summary_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/program/getProgramSummary`,
        method: "POST",
        body: { user_id: globalUserId, program_id: program_id, summary_id: summary_id }
    });
}

export const invokeGetWorkoutExerciseDetails = (user_id, program_id, block_id, set_id, day_block_ids) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/exercise/getWorkoutExerciseDetails`,
        method: "POST",
        body: { user_id: user_id, program_id: program_id, block_id: block_id, set_id: set_id, day_block_ids: day_block_ids }
    });
}

/***** YOGA EXERCISE DETAILS *****/
export const invokeGetYogaWorkoutDetails = (program_id) => {
    var globalUserId = getUserId();
    console.log("getYogaWorkoutDetails...");
    return invokeApig({
        path: `/program/getWorkout`,
        method: "POST",
        body: { screen: "getYogaWorkoutDetails", user_id: globalUserId, program_id: program_id }
    });
}

export const invokeGetProgramWorkoutDates = (program_id, summary_id) => {
    var globalUserId = getUserId();
    return invokeApig({
        path: `/athlete/program/getProgramWorkoutDates`,
        method: "POST",
        body: { user_id: globalUserId, program_id: program_id, summary_id: summary_id }
    });
}

export const invokeGetProgramDayWorkout = (user_id, mktplc_program_id, program_id, day_id, curr_week, curr_day) => {
    var globalUserId = getUserId();
    var company_id   = localStorage.getItem('globalUserCompanyId');

    return invokeApig({
        path: `/athlete/program/getProgramDayWorkout`,
        method: "POST",
        body: { user_id: user_id, company_id: company_id, mktplc_program_id: mktplc_program_id, program_id: program_id, day_id: day_id, curr_week: curr_week, curr_day: curr_day }
    });
}

export const invokeSetAthleteExerciseMetrics = (screen, user_id, program_id, block_id, set_number, set_id, exercise_id, psmv_id, metric_a, metric_b, metric_a_id, metric_b_id, one_rep_max, set_completed) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/exercise/setAthleteExerciseMetrics`,
        method: "POST",
        body: { screen: screen, user_id: user_id, program_id: program_id, block_id: block_id, set_number: set_number, set_id: set_id, exercise_id: exercise_id, psmv_id: psmv_id, metric_a: metric_a, metric_b: metric_b, metric_a_id: metric_a_id, metric_b_id: metric_b_id, one_rep_max: one_rep_max, set_completed: set_completed }
    });
}


/*********************   BEGIN: DELETE AUGUST   ***************/
/*  This function will be deleted in 3 months and be replaced with Vers2 directly below       */
/*  This is being kept online in case someone with an older TS version invokes this function  */
/*  However, after 1-3 months the latest version of TS should be in use by all users          */
export const invokeSetAthleteExerciseMetricsSaveAll = (user_id, metric_set_numbers, metric_a_vals, metric_b_vals, metric_a_ids, metric_b_ids, metric_psmv_ids, metric_set_ids, metric_exercise_ids, program_id, block_id) => {
    var globalUserId = getUserId();
    //console.log("invokeSetAthleteExerciseMetricsSaveAll ...");

    return invokeApig({
        path: `/athlete/exercise/setAthleteExerciseSaveAllMetrics`,
        method: "POST",
        body: { user_id: user_id, program_id: program_id, block_id: block_id, metric_set_numbers: metric_set_numbers, metric_a_vals: metric_a_vals, metric_b_vals: metric_b_vals, metric_a_ids: metric_a_ids, metric_b_ids: metric_b_ids, metric_psmv_ids: metric_psmv_ids, metric_set_ids: metric_set_ids, metric_exercise_ids: metric_exercise_ids }
    });
}
/*********************   END: DELETE AUGUST   ***************/

/**************  BEGIN: TESTING   ***************/
export const invokeSetAthleteExerciseSaveAllMetricsVers2 = (metric_arr) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/exercise/setAthleteExerciseSaveAllMetricsVers2`,
        method: "POST",
        body: { metric_arr: metric_arr }
    });
}
/**************  END: TESTING   ***************/

export const invokeGetAthleteExerciseHistory = (user_id, exercise_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/exercise/getAthleteExerciseHistory`,
        method: "POST",
        body: { user_id: user_id, exercise_id: exercise_id }
    });
}


export const getUserProfileValidation = (email, company_id) => {
    return invokeApig({
        path: `/athlete/utils/getUserProfileValidation`,
        method: "POST",
        body: { email: email, company_id: company_id }
    });
}

//// This is used only for Posture Health clients ////
//// It retrieves a "not a user" general profile  ////
export const invokeGetGeneralPostureNotAUserProfile = () => {

    var email      = "test";
    var company_id = "test";

    return invokeApig({
        path: `/athlete/utils/getUserProfileValidation`,
        method: "POST",
        body: { screen: "getGeneralPostureNotAUserProfile", email: email, company_id: company_id }
    });
}


export const invokeGetWorkoutAllExerciseMetrics = (user_id, day_id, program_id) => {
    //var globalUserId = globalUserId();

    return invokeApig({
        path: `/athlete/exercise/getWorkoutAllExerciseMetrics`,
        method: "POST",
        body: { user_id: user_id, day_id: day_id, program_id: program_id }
    });
}

/*******************************************/
/****   CHANGE globalUserId to UserId   ****/
export const invokeSetJoinWorkoutProgram = (program_id, summary_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: `/athlete/program/setJoinWorkoutProgram`,
        method: "POST",
        body: { user_id: globalUserId, program_id: program_id, summary_id: summary_id }
    });
}

export const invokeSetUnsubscribeAthleteFromMktplcProgram = (new_program_id) => {
    var globalUserId = getUserId();
    console.log("new_program_id: " + new_program_id);
    return invokeApig({
        path: `/athlete/program/setDeleteSingleProgram`,
        method: "POST",
        body: { screen: "setUnsubscribeAthleteFromMktplcProgram", user_id: globalUserId, subscriber_program_id: new_program_id }
    });
}

/*******************************************/
/****   CHANGE globalUserId to UserId   ****/
export const invokeSetDeleteSingleProgram = (program_id) => {
    var globalUserId = getUserId();

    /*return invokeApig({
        path: `/athlete/program/setDeleteSingleProgram`,
        method: "POST",
        body: { screen: "setDeleteProgram", user_id: globalUserId, program_id: program_id }
    });*/
}


/*******************************************/
/****   CHANGE globalUserId to UserId   ****/
/////   AUTO FILL MEMBER NAME    ////
export const invokeGetTrainerName = (company_id, search_str) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: '/athlete/trainer/getTrainerName',
        method: "POST",
        body: { creator_id: globalUserId, company_id: company_id, search_str: search_str }
    });
}

/********************************************************************************************/
/***********************************   MESSAGE SECTION   ************************************/
/********************************************************************************************/

export const invokeGetSummaryMessages = (creator_id, search_term, number_of_rows) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/athlete/message/getMessages",
        method: "POST",
        body: { creator_id: creator_id, screen: "getSummaryMessages", search_term: search_term, number_of_rows: number_of_rows }
    });
}

export const invokeGetMessageDetail = (creator_id, message_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/athlete/message/getMessages",
        method: "POST",
        body: { creator_id: creator_id, screen: "getMessageDetail", message_id: message_id, search_term: '%', number_of_rows: 50 }
    });
}

export const invokeSetMessageAdd = (creator_id, message_id, recipient_id, body) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/athlete/message/setMessages",
        method: "POST",
        body: { creator_id: creator_id, screen: "setMessageAdd", message_id: message_id, participant_id: recipient_id, body: body }
    });
}

export const invokeSetMessageDelete = (creator_id, message_id, recipient_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/athlete/message/setMessages",
        method: "POST",
        body: { creator_id: creator_id, screen: "setMessageDelete", message_id: message_id, participant_id: recipient_id, body: null }
    });
}

export const invokeGetUnreadMessages = (creator_id) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/athlete/message/getUnreadMessages",
        method: "POST",
        body: { user_id: creator_id }
    });
}

/*********************************************************************************************/
/***********************************   TEXT MSG SECTION   ************************************/
/*********************************************************************************************/

export const invokeSendNewTextMessage = (name, phone_to) => {
    var globalUserId = getUserId();

    return invokeApig({
        path: "/text_msg/awsSNS",
        method: "POST",
        body: { name: name, phone_to: phone_to }
    });
}



// WEBPACK FOOTER //
// ./src/utils/AwsInvoke.js